import React, {useState} from 'react'
import AgeGroupVsTimeChart from '../components/graphs/AgeGroupVsTimeChart'

function Summary() {
  
  return (
    <div>
      <AgeGroupVsTimeChart/>
    </div>
  )
}

export default Summary
